import React from "react";

const CV_FILENAME = "Pradeep-Singh-CV.pdf";

const loadCvDocument = () => import("./pdf/CvDocument");

const triggerBlobDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

/** Lazy-load react-pdf and download the ATS CV PDF from cv.js. */
export async function downloadCvPdf() {
  const [{ pdf }, { default: CvDocument }] = await Promise.all([
    import("@react-pdf/renderer"),
    loadCvDocument(),
  ]);

  const blob = await pdf(React.createElement(CvDocument)).toBlob();
  triggerBlobDownload(blob, CV_FILENAME);
}
